import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import { getMallUserIdByToken } from '@/services/auth.service';

const mall = { baseURL: apiUrls.mall };

export interface UpdateUserInfoReq {
    phoneNumber?: string;
    email?: string;
    nickname?: string;
}

/**
 * 현재 로그인 사용자 정보 patch.
 * - path의 식별자는 토큰의 flowing userId 가 아니라 **mall user id** 가 필요하므로
 *   먼저 getMallUserIdByToken() 으로 조회해 URL 에 끼워 넣는다.
 * - mall user id 가 없으면(=mall 가입이 안 됐으면) 호출 자체를 차단한다.
 */
export const updateUserInfo = async (body: UpdateUserInfoReq): Promise<void> => {
    const mallUserId = await getMallUserIdByToken();
    if (!mallUserId) {
        throw new Error('현재 몰에 가입된 사용자 정보를 찾을 수 없어요.');
    }
    await api.patch(`/main/${mallUserId}/info`, body, mall);
};
